import React, { forwardRef, useImperativeHandle, useRef } from 'react';

const FileUploader = forwardRef(({ onFileSelectSuccess }, ref) => {
  const fileInput = useRef(null);

  const handleFileInput = (e) => {
    const file = e.target.files[0];
    onFileSelectSuccess(file);
  };

  useImperativeHandle(ref, () => ({
    clear: () => {
      if (fileInput.current) {
        fileInput.current.value = ''; // 清空文件選擇器
      }
    },
  }));

  return (
    <div className="file-uploader">
      <input type="file" ref={fileInput} onChange={handleFileInput} />
    </div>
  );
});

export default FileUploader;